import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from './use-auth';

/**
 * Hook que garante sincronização do activeCompany baseado no slug da URL
 * Útil em layouts de sistemas que dependem do contexto da empresa via rota
 */
export function useEnsureActiveCompany() {
  const { slug } = useParams<{ slug: string }>();
  const { companies, activeCompany, setActiveCompany } = useAuth();

  useEffect(() => {
    // Só atua se:
    // 1. Há um slug na URL
    // 2. As companies já foram carregadas
    // 3. activeCompany não está setado OU está setado para empresa diferente do slug
    if (!slug || companies.length === 0) {
      return;
    }

    const targetCompany = companies.find(c => c.slug === slug);
    
    if (!targetCompany) {
      console.warn(`🧭 [ensure-active-company] Company with slug "${slug}" not found in user companies`);
      return;
    }

    // Se activeCompany já está correto, não faz nada
    if (activeCompany?.slug === slug) {
      console.log(`🧭 [ensure-active-company] activeCompany already synchronized with slug "${slug}"`);
      return;
    }

    // Sincronizar
    console.log(`🧭 [ensure-active-company] Synchronizing activeCompany from slug "${slug}"`, {
      targetCompany: {
        id: targetCompany.id,
        name: targetCompany.name,
        slug: targetCompany.slug
      },
      previousActiveCompany: activeCompany ? {
        id: activeCompany.id,
        name: activeCompany.name,
        slug: activeCompany.slug
      } : null
    });

    setActiveCompany(targetCompany);
  }, [slug, companies, activeCompany, setActiveCompany]);
}
